(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.navigation = {
    attach: function (context, settings) {
      const $mobileNavMenu = $('.js-small-menu', context);
      const $mobileNavButton = $('.js-small-menu-button', context);
      const $mobileSubNavButton = $('.main-menu__link--expanded', context);

      $mobileNavButton.on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).text('Menu');
          $mobileNavMenu.removeClass('active');
          $('.js-small-menu .main-menu__link--expanded', context).each(function () {
            $(this).removeClass('active');
            $(this).next('.main-menu--sub').removeClass('active');
          });
        } else {
          $(this).addClass('active');
          $mobileNavMenu.addClass('active');
          $(this).text('Close Menu');
        }
      });

      $mobileSubNavButton.on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        if ($this.hasClass('active')) {
          $this.removeClass('active');
          $this.next('.main-menu--sub').removeClass('active');
        } else {
          $this.addClass('active');
          $this.next('.main-menu--sub').addClass('active');
          $mobileSubNavButton.not($this).removeClass('active');
          $mobileSubNavButton.not($this).next('.main-menu--sub').removeClass('active');
        }
      });

      // This shouldn't really go here but I felt it was a bit much to create an entire file for this block
      // Please move it if a more relevant file gets created in the future
      $('[type="checkbox"]~.description, [type="radio"]~.description', context).on('click', function () {
        const checkBox = $(this).siblings('.form-checkbox');
        if (checkBox.is(':checked')) {
          $(checkBox).prop('checked', false);
        } else {
          $(checkBox).prop('checked', true);
        }
      });
    }
  };
})(jQuery, Drupal);
